import Edit from "./Edit";

const { registerBlockType } = wp.blocks;
// import Edit from "./Edit";
import metadata from "../../../blocks/playlist-narrow/block.json";

if (window.h5apPlayer?.isPipe) {
  registerBlockType(metadata, {
    getEditWrapperProps: () => {
      return {
        className: "h5ap-block-wrapper",
      };
    },
    edit: Edit,
    // save: Save,
    save: () => null,
  });
}
